import { styled } from 'linaria/react';
import React from 'react';
import { useQuery } from 'react-apollo';
import { theme } from '../../Theming/Theming';
import { RowProducts } from '../../ui/ProductRow/RowProducts';
import AddonProductQuery from './AddonProductQuery.gql';

const AddonProductsWrapper = styled('div')`
  margin: 1rem 0 1rem 0;
  width: 100%;
  > h3 {
    margin: 1rem 0;
  }
  //SLIDER WIDTH
  .slider-items {
    > * {
      margin-right: 5%;
      ${theme.only.sm} {
        width: 50%;
      }
      ${theme.only.md} {
        width: 50%;
      }
      ${theme.only.lg} {
        width: 40%;
      }
      ${theme.above.xl} {
        width: 40%;
      }
    }
  }
`;

const AddonProducts = ({
  list,
  mainProduct,
  slider = true,
  className = 'tight',
}) => {
  const result = useQuery(AddonProductQuery, {
    variables: { articleNumbers: list },
    errorPolicy: 'all',
  });

  const products = result?.data?.products;

  const category = {
    name: 'Spareparts for' + mainProduct.articleNumbers,
    products: {
      result: products,
    },
  };

  return (
    <AddonProductsWrapper id="spare-parts-wrapper">
      <RowProducts
        category={category}
        slider={slider}
        quickBuy={true}
        className={className}
      />
    </AddonProductsWrapper>
  );
};

export default AddonProducts;
